import { SEARCH_INPUT_VALUE } from "./actionType";

const initialState = "";

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_INPUT_VALUE:
      return action.payload;
    default:
      return state;
  }
};

export default searchReducer;
